import { BaseApi } from './base.api.js';

export class ExerciseParticipantApi extends BaseApi {
    constructor(client) {
        super(client, '/exercise-participants');
    }
}
